// 例: assets/custom-animation.js に記述

document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.section-to-animate');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -100px 0px' // 画面の下端から100px手前で発動
    });

    sections.forEach(section => {
      observer.observe(section);
    });
  }
});